import { Trans } from '@lingui/react/macro';
import classNames from 'classnames';
import React from 'react';
import { DivProps } from 'typings';
import UDInput from 'ud-form/components/input/component';
import UDText from '../text';

interface IProps extends Omit<DivProps, 'onChange'> {
  onChange: (value: number) => void;
  value: number;
}

function UDPerPage(props: IProps) {
  const { onChange, value, className, ...rest } = props;

  return (
    // `className` именно мержится, а не разворачивается из `rest`: иначе любой
    // переданный класс затирал бы раскладку, и подпись с полем вставали в две строки.
    <div className={classNames('flex items-center text-nowrap', className)} {...rest}>
      <UDText type="subhead" className="text-surfaceRomanSilver30 mr-2 ml-auto whitespace-nowrap">
        <Trans>На странице:</Trans>
      </UDText>
      <UDInput
        type="number"
        wrapperProps={{ className: 'w-[80px]' }}
        min={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </div>
  );
}

export default UDPerPage;
